import axios from 'axios'

const state = { 
    postulants: []
};

const getters = { 
    postulantsList: state => state.postulants
};

const actions = { 
    async fetchPostulants({commit},num=1){
        var url = process.env.VUE_APP_URL_API+'/auth/postulants/all?page='+num;
        var token = window.localStorage.getItem('token');

        var params =  {
            headers: {
                Authorization: token,
            }
        }

        const response = await axios.get(url,params)
                            .catch(
                                error => {
                                    if (error.response.status === 401) {
                                        window.localStorage.removeItem('token');
                                        window.localStorage.removeItem('user');
                                        window.location.href = "/";
                                    }
                                    if (error.response.status === 404) {
                                        console.log('error 404, Endpoint no encontrado.')
                                    }
                                }
                            );
        commit("setPostulants", response.data.data);
    }
};

const mutations = { 
    setPostulants: (state, postulants) => (
        state.postulants = postulants
    )
};

export default {
    state,
    getters,
    actions,
    mutations
}